import { Store } from 'vuex';
import { EventEmitter } from 'events';

/* tslint:disable:no-console */

const BluetoothDeviceNamePrefix: string = 'AM1';
const ServiceUuid: string = '00000000-0001-11e1-9ab4-0002a5d5c51b';
const CharacteristicUuid: string = '00e00000-0001-11e1-ac36-0002a5d5c51b';


export default class BluetoothManager extends EventEmitter {
    // private devices = new Map<string, BluetoothDevice>();
    // private characteristics = new Map<string, BluetoothRemoteGATTCharacteristic>();

    private store: Store<any>;

    public constructor(store: Store<any>) {
        super();
        this.store = store;
    }

    public addDevice(label: string) {
        let device: BluetoothDevice;
        const requestOptions: RequestDeviceOptions = {
            filters: [{ namePrefix: BluetoothDeviceNamePrefix}],
            optionalServices: [ServiceUuid],
        };

        navigator.bluetooth.requestDevice(requestOptions)
        .then((dev: any) => {
                const gatt = dev.gatt;
                if (gatt !== undefined) {
                    device = dev;
                    this.storeDevice(label, dev);
                    return gatt.connect();
                }
        })
        .then((server: BluetoothRemoteGATTServer) => {
            console.log('getting primary service');
            return server.getPrimaryService(ServiceUuid);
        })
        .then((service: BluetoothRemoteGATTService) => {
            console.log('getting characteristic');
            return service.getCharacteristic(CharacteristicUuid);
        })
        .then((characteristic: BluetoothRemoteGATTCharacteristic) => {
            console.log('characteristic found');
            this.emit('connected', device, label );
            this.storeCharacteristic(label, characteristic);
        })
        .catch((error) => {
            console.log(error.message);
            this.emit('error', error.message);
        });
    }

    public startNotifications() {
        const characteristics = this.store.getters.characteristics ;
        characteristics.forEach((characteristic: BluetoothRemoteGATTCharacteristic, label: string) => {
            characteristic.startNotifications().then( () => {
                characteristic.addEventListener('characteristicvaluechanged', (event: any) => {
                    const value = event.target ? event.target.value : 0;
                    this.emit('data', label, value);
                });
            });
        });
    }

    public stopNotifications() {
        const characteristics = this.store.getters.characteristics ;
        characteristics.forEach((characteristic: BluetoothRemoteGATTCharacteristic, label: string) => {
            characteristic.stopNotifications();
        });
    }

    private storeDevice(label: string, device: BluetoothDevice) {
        this.store.commit('addDevice', {label, device});
    }

    private storeCharacteristic(label: string, characteristic: BluetoothRemoteGATTCharacteristic) {
        this.store.commit('addCharacteristic', {label, characteristic});
    }
}
